import React from 'react';
import {Typography} from '~library/atoms/Typography';
import {Button} from '~library/atoms/Button';
import {TRANSFORM_TYPES} from '../contants';
import {RotateControl} from './RotateControl';
import {SizeControl} from './SizeControl';
import {FlipControl} from './FlipControl';
import {ReflectVerticalIcon} from '~library/svg/ReflectVerticalIcon';
import {RevisionIcon} from '~library/svg/RevisionIcon';
import {ExpandIcon} from '~library/svg/ExpandIcon';
import './TransformMenu.sass';

const TRANSFORM_OPTIONS = [
  {
    id: TRANSFORM_TYPES.ROTATE,
    icon: <RevisionIcon />,
    label: 'Rotate',
  },
  {
    id: TRANSFORM_TYPES.SIZE,
    icon: <ExpandIcon />,
    label: 'Size',
  },
  {
    id: TRANSFORM_TYPES.FLIP,
    icon: <ReflectVerticalIcon />,
    label: 'Flip',
  },
];

export const TransformMenu = ({activeTransform, setActiveTransform, canvas}) => {
  const renderTransformControl = () => {
    switch (activeTransform) {
      case TRANSFORM_TYPES.ROTATE:
        return <RotateControl canvas={canvas} />;
      case TRANSFORM_TYPES.SIZE:
        return <SizeControl canvas={canvas} />;
      case TRANSFORM_TYPES.FLIP:
        return <FlipControl canvas={canvas} />;
      default:
        return null;
    }
  };

  return (
    <div className="transform-menu">
      <div className="transform-menu__control">{renderTransformControl()}</div>

      <div className="transform-menu__tabs">
        {TRANSFORM_OPTIONS.map((option) => (
          <Button
            variant="unstyled-button"
            key={option.id}
            className={`transform-menu__tab ${activeTransform === option.id ? 'transform-menu__tab--active' : ''}`}
            onClick={() => setActiveTransform(option.id)}
            data-qa-id={`transform-${option.id}-btn`}
          >
            <div className="transform-menu__tab-icon">{option.icon}</div>
            <Typography
              variant="paragraph3"
              classNames={`transform-menu__tab-label ${activeTransform === option.id ? 'transform-menu__tab-label--active' : ''}`}
            >
              {option.label}
            </Typography>
          </Button>
        ))}
      </div>
    </div>
  );
};
